<template>
  <div>
    <van-nav-bar title="标准限值" :fixed="true" :left-arrow="!hideBackBtn" @click-left="goback" />
    <div class="standardLimits">
      <h5>依据：GB 3838 - 2002 地表水环境质量标准</h5>
      <div class="limitTable">
        <el-table :data="tableData" :span-method="arraySpanMethod" >
          <el-table-column prop="name" label="限值项目" align="center" >
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <div>
                  <span style="display: block; line-height: 16px;font-weight: 600">{{ scope.row.name }}</span>
                  <span style="display: block; font-size: 12px; line-height: 14px;">{{ scope.row.unit }}</span>
                </div>
                <div v-show="scope.row.symbol" style="padding-right: 4px">
                  {{ scope.row.symbol }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="基本项目标准限值" align="center">
            <el-table-column align="center" prop="level1" label="I类" width=55>
              <template slot-scope="scope">
                <span v-if="scope.row.name === '水温'">
                  <span>
                    人为造成的环境水温变化应限制在：
                  </span>

                  <div>
                    周平均最大温升≤1
                  </div>
                  <div>
                     周平均最大温降≤2
                  </div>
                </span>
                <span v-else>{{ scope.row.level1 }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="level2" label="II类" width=55></el-table-column>
            <el-table-column align="center" prop="level3" label="III类" width=55></el-table-column>
            <el-table-column align="center" prop="level4" label="IV类" width=55></el-table-column>
            <el-table-column align="center" prop="level5" label="V类" width=55></el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "standardLimits",
  data() {
    return {
      tableData: [
        {
          name: "CODcr",
          level1: 15,
          level2: 15,
          level3: 20,
          level4: 30,
          level5: 40,
          unit: "mg/L",
          symbol: "≤"
        },
        {
          name: "氨氮",
          level1: 0.15,
          level2: 0.5,
          level3: 1,
          level4: 1.5,
          level5: 2,
          unit: "mg/L",
          symbol: "≤"
        },
        {
          name: "溶解氧",
          level1: 7.5,
          level2: 6,
          level3: 5,
          level4: 3,
          level5: 2,
          unit: "mg/L",
          symbol: "≥"
        },
        {
          name: "PH",
          level1: "6~9",
          unit: "无量纲",
        },
        {
          name: "水温",
          level1: "人为造成的环境水温变化应限制在：周平均最大温升≤1, 周平均最大温降≤2",
          unit: "°C",
        }
      ]
    };
  },
  computed: {
    ...mapState(['hideBackBtn'])
  },
  methods: {
    goback() {
      window.history.back();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 3) {
        if (columnIndex === 1) {
          return [1, 5];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
      if (rowIndex === 4) {
        if (columnIndex === 1) {
          return [1, 5];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    }
  }
};
</script>

<style scoped>
.standardLimits {
  padding-top: 15px;
}
.standardLimits h5 {
  text-align: center;
}
.limitTable {
  width: 354px;
  margin: 0 auto;
  /* padding: 10px; */
}
.limitTable table {
  width: 100%;
}
.limitTable table thead {
  /* display: flex; */
}
</style>


// WEBPACK FOOTER //
// src/pages/application/standardLimits.vue